/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useContext } from 'react';
import commands from './commands';
import MetricsContext from './MetricsContext';
import cx from 'classnames';

export default (): Element<string> => {
  const ctx = useContext(MetricsContext);
  const isCustomizing = ctx.state.mode === 'CUSTOMIZING';
  const isReady = ctx.state.mode === 'READY';

  return (
    <button
      onClick={() => {
        isCustomizing && commands(ctx).doneCustomizing();
        isReady && commands(ctx).startCustomizing();
      }}
      css={css(`
        font-weight: bold;
        span { display: inline-block; margin-right: 10px; }
      `)}
    >
      {isCustomizing && <span>DONE</span>}
      {isReady && <span>CUSTOMIZE</span>}
      <i
        className={cx('fa', {
          'fa-cog': isReady,
          'fa-check': isCustomizing,
          'text-success': isCustomizing,
        })}
      />
    </button>
  );
};
